import { IServerOrder } from '@rbi-ctg/menu';

export const truncateCartEntriesForLog = (
  cartEntries: { sanityId?: string | undefined; name?: string | undefined }[] | undefined | null
) => {
  try {
    if (!cartEntries) {
      return cartEntries;
    }

    if (!Array.isArray(cartEntries)) {
      return cartEntries;
    }
    return cartEntries.map(entry => ({
      sanityId: entry.sanityId,
      name: entry.name,
    }));
  } catch (error) {
    return undefined;
  }
};

export const truncateServerOrderForLog = (serverOrder: IServerOrder | undefined | null) => {
  return {
    ...serverOrder,
    cart: {
      ...serverOrder?.cart,
      cartEntries: truncateCartEntriesForLog(serverOrder?.cart?.cartEntries),
    },
  };
};
